import { AuthDanceSchoolUserRoleInterface, DanceManagerUserRoleEnum } from '../../..';
// TODO:Serdar - sollte in der Entity verwendet werden, in dem das Interface verwendet wird

export class DanceSchoolRoleToUserDto implements AuthDanceSchoolUserRoleInterface {
  danceSchoolUserRole: DanceManagerUserRoleEnum;
  validFrom: Date;
  validUntil: Date;
}
